module.exports = __webpack_public_path__ + "static/media/landscape-cropx6.76de1e4f.webp";